module.exports = __webpack_public_path__ + "img/placeholder_2025.8c15ebe0.png";